'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'download_app_banner',
    viewClass: require('./view'),
    modelClass: require('./model'),
    methods: {
        trackEventCategory: function(data) {
            this.model.categoryItem = data;
        },
        dataTrack: function(data) {
            $(this.selectors.linkFooter).attr('track-category', data);
        },
    },
});
